import db from "../../firebaseConfig";
import {DASHBOARD_REQUEST_FAILED, DASHBOARD_REQUEST_START, DASHBOARD_REQUEST_SUCCESS } from "./dashboardTypes";
import {DIAMONDS_COLLECTION, ADMINS_COLLECTION, USERS_COLLECTION, TOPUPS_COLLECTION} from '../../constants';

export const startRequest = () => {
    return {
        type: DASHBOARD_REQUEST_START
    }
}

export const successRequest = data => {
    return {
        type: DASHBOARD_REQUEST_SUCCESS,
        payload: data
    }
}

export const failedRequest = error => {
    return {
        type: DASHBOARD_REQUEST_FAILED,
        payload: error
    }
}


export const getDashboardInformation = () => {
    return async (dispatch) => {

        dispatch(startRequest());

        let data = {
            diamonds: {},
            topups: {},
            users: {},
            admins: {}
        };

        // await db.collection(DIAMONDS_COLLECTION)
        // .get()
        // .then(collections => {
        //     let activeDiamonds = collections.docs.filter(doc => doc.data().status === true).length;

        //     const diamondsData = {
        //         total: collections.size,
        //         active: activeDiamonds
        //     };

        //     data.diamonds = diamondsData;
        // });

        await db.collection(TOPUPS_COLLECTION)
        .get()
        .then(collections => {

            let todayTopup = collections.docs.filter(doc => new Date(doc.data().createdAt.seconds * 1000).toLocaleDateString() === new Date().toLocaleDateString()).length;

            let pending = collections.docs.filter(doc => doc.data().status === 'pending').length;
            let processing = collections.docs.filter(doc => doc.data().status === 'processing').length;
            let canceled = collections.docs.filter(doc => doc.data().status === 'canceled').length;
            let done = collections.docs.filter(doc => doc.data().status === 'done').length;

            const topupsData = {
                total: collections.size,
                newToday: todayTopup,
                pending: pending,
                processing: processing,
                canceled: canceled,
                done: done,
            };

            data.topups = topupsData;
        });

        await db.collection(USERS_COLLECTION)
        .get()
        .then(collections => {

            let todayUsers = collections.docs.filter(doc => new Date(doc.data().createdAt.seconds * 1000).toLocaleDateString() === new Date().toLocaleDateString()).length;

            
            const usersData = {
                total: collections.size,
                newToday: todayUsers
            };

            data.users = usersData;
        });
        
        // await db.collection(ADMINS_COLLECTION)
        // .get()
        // .then(collections => {

        //     let todayAdmins = collections.docs.filter(doc => new Date(doc.data().createdAt.seconds * 1000).toLocaleDateString() === new Date().toLocaleDateString()).length;

            
        //     const adminsData = {
        //         total: collections.size,
        //         newToday: todayAdmins
        //     };

        //     data.admins = adminsData;
        // });
        dispatch(successRequest(data));
    }
}
